import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
// import './style.scss';
import Content from "../../../layout/content/Content";
import classNames from "classnames";
import Head from "../../../layout/head/Head";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PaginationComponent,
    Row,
    Col,

    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
    TooltipComponent

} from "../../../components/Component";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import { QueryClient, QueryClientProvider, useQuery, useMutation } from "@tanstack/react-query";
import { loginAxios } from '../../../config/axios.config';
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import './style.scss';
import TableHead from "../common/TableHead";
import { useSelector, useDispatch } from 'react-redux';
import { getDateFormat } from "../../../utils/Utils";

const OpenDebitNoteListing = () => {

    const fileUploadMsg = useSelector((state) => state.commonReducer.fileUploadMsg);

    const history = useHistory();
    const dispatch = useDispatch();

    const { errors, register, handleSubmit, control, reset } = useForm();

    const [data, setData] = useState([]);
    const [onSearch, setonSearch] = useState(true);
    const [onSearchText, setSearchText] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(20);
    const [sort, setSortState] = useState("DESC");

    const [totalCount, setTotalCount] = useState('');

    const [searchData, setSearchData] = useState({ invoice_number: '', po_numbers: '' });


    const formClass = classNames({
        "form-validate": true,
        "is-alter": true,
    });

    const sortFunc = (val) => {

        console.log(val);
    };

    const onFilterChange = (e) => {
        setSearchText(e.target.value);
    };

    // Get current list, pagination
    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);


    useEffect(async () => {

        const indexOfLastItem = currentPage * itemPerPage;
        const indexOfFirstItem = indexOfLastItem - itemPerPage;

        console.log(searchData);

        var payload = {
            sort: sort,
            offsetItem: indexOfFirstItem,
            invoice_number: searchData?.invoice_number,
            // po_numbers: searchData?.po_numbers,
            // startDate: searchData?.startDate,
            // endDate: searchData?.endDate,
            itemPerPage

        }

        refetchPOList.mutate(payload)
    }, [itemPerPage, currentPage, sort, searchData]);


    const getInvoiceListing = async (param) => {

        console.log(param);

        // let startDate = typeof param.startDate !== "undefined" && param.startDate !== "Invalid date" ? param.startDate : "";
        // let endDate = typeof param.endDate !== "undefined" && param.endDate !== "Invalid date" ? param.endDate : "";
        try {                
                // const { data } = await loginAxios.get(`payment/list-open-debit-note?sortBy=${param.sort}&offset=${param.offsetItem}&limit=${param.itemPerPage}&invoice_number=${param.invoice_number}`, {
                    const { data } = await loginAxios.get(`payment/list-open-debit-note?offset=${param.offsetItem}&limit=${param.itemPerPage}`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const refetchPOList = useMutation(['getInvoiceListing'], getInvoiceListing, {
        // refetchOnMount: false,
        // refetchOnWindowFocus: false,
        onSettled(data, error) {
            if (data) {

                console.log(data.data);
                setData(data.data.result);

                setTotalCount(data.data.total_count)
            }
        }
    })



    const [modalLg, setModalLg] = useState(false);
    const toggleLg = () => setModalLg(!modalLg);

    const [trackingData, setTrackingData] = useState({});

    const [poNumber, setPoNumber] = useState('');

    const [dispatchModal, setdispatchModal] = useState(false);
    const toggleDispatchModal = () => {
        setdispatchModal(!dispatchModal);
        setPoNumber('');
        setDispatchDate('');
        reset();
    };


    const getTrackingDetails = async (param) => {
        try {
            const { data } = await loginAxios.get(`designers/view-trcking-details?order_detail_id=${param}`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };


    const getTrackingDetailsCall = useMutation(getTrackingDetails, {
        onSettled(data, error) {
            if (data) {
                setTrackingData(data?.data?.result);
            } else if (error) {
                console.log(error);
            }
        }
    })



    /////////////////////////////////////////////DISPATCH PO ///////////////////////////////////////////////////////////////////////


    const dispatchPO = async (params) => {
        try {
            const { data } = await loginAxios.post(`designers/dispatch-po`, params, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };


    const dispatchPOCall = useMutation(dispatchPO, {
        onSettled(data, error) {
            toggleDispatchModal();
            if (data) {
                console.log(data);


                toast.success(data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    progress: false,
                });

            } else if (error) {
                console.log(error);

                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    progress: false,
                });
            }
        }
    })

    /////////////////////////////////////////////DISPATCH PO ///////////////////////////////////////////////////////////////////////


    const handleViewDetails = (item) => {
        let invoiceID = item?.invoice_number?.replace("DIN", "");
        window.open(`/view-invoice-details?invoice_number=${invoiceID}`, '_blank');
    }
    
    const handleUpdateDetails = (item) => {
        let invoiceID = item?.invoice_number?.replace("DIN", "");
        window.open(`/upload-invoice?po_type=update&invoice_id=${invoiceID}&fc_id=${item?.fc_id}`, '_self')                
    }


    const handleDispatchPO = (item) => {
        toggleDispatchModal();
        setPoNumber(item.poNumber);
    }


    const onFormSubmit = (e) => {
        console.log(e);
        var payload = e;
        payload.po_numbers = parseInt(e.po_numbers);
        console.log(payload)
        dispatchPOCall.mutate(payload);
    }

    const [dispatchDate, setDispatchDate] = useState('');
    const [infoText, setInfoText] = useState('');
    const [userGuideModal, setuserGuideModal] = useState(false);

    const toggleuserGuideModal = (val) => {
        setuserGuideModal(!userGuideModal);

        if (val != undefined) {
            setInfoText(val);
        }
    };


    const searchHandler = async (data) => {
        setCurrentPage(1);
        setSearchData(data);
        console.log(data);
    };



    let seachFeild = {
        // po_numbers: '',
        invoice_number: '',
    };



    const seachFeildType = {

        // po_numbers: {
        //     tag: "input",
        //     type: "text",
        // },
        invoice_number: {
            tag: "input",
            type: "text",
        }

    };


    const handleGetData = () => {
        setSearchData({ invoice_number: '', po_numbers: '' });
    }

    const handleAdd = () => {
        history.push('/invoice-add')
    }

    const handleEditInvoice = (item) => {
        console.log(item)
        history.push(`/invoice-edit/${item.id}`);
    }



    useEffect(() => {        

        if (fileUploadMsg?.status == true) {
            toast.success(fileUploadMsg?.msg, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                progress: false,
            });

            dispatch({ type: 'BULK_UPDATE_FILE_UPLOAD', payload: {} });

        } else if (fileUploadMsg?.status == false) {
            toast.error(fileUploadMsg?.msg, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                progress: false,
            });

            dispatch({ type: 'BULK_UPDATE_FILE_UPLOAD', payload: {} });
        }

    }, [fileUploadMsg]);


    const truncatePoNum = (val) => {
        let poNums = val;
        let poNumsSplit = poNums.split(',');

        return(<> {

        poNumsSplit.map((elem, i) => {
            if (i % 4 == 0 && i != 0) {
                return <><span>{elem}</span>{i == poNumsSplit.length - 1 ? '' : ','}<br /></>
            } else {
                return <><span>{elem}</span>{i == poNumsSplit.length - 1 ? '' : ','}</>
            }
        })        
    }</>)
    }

    return (
        <React.Fragment>
            <Head title="Invoice List"></Head>
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page>Open Debit Note/Invoice
                                {/* <Icon style={{ fontSize: '18px' }} name="help" onClick={() => toggleuserGuideModal('purchaseOrder')}></Icon> */}
                            </BlockTitle>
                        </BlockHeadContent>

                    </BlockBetween>
                </BlockHead>

                <Block>
                    <Card className="card-stretch">

                        {/* <Row className="gy-3">
                            <Col lg={10}>
                                <TableHead
                                    searchHandler={searchHandler}
                                    searchFieldData={seachFeild}
                                    seachFeildType={seachFeildType}
                                    reloadHandler={() => {
                                        handleGetData();
                                    }}
                                    setSearchText={setSearchText}
                                    setSelectedItems={setSelectedItems}
                                    pageName="purchase-order-listing"
                                    showDatePicker={false}
                                />
                            </Col>
                            <Col lg={2} >

                                <div style={{ display: 'flex', height: '100%' }}>

                                    <div className="card-tools mr-n1" style={{ alignItems: 'center' }}>
                                        <ul className="btn-toolbar">
                                            <li>
                                                <UncontrolledDropdown>
                                                    <DropdownToggle
                                                        tag="a"
                                                        href="#toggle"
                                                        onClick={(ev) => ev.preventDefault()}
                                                        className="link link-light link-sm dropdown-indicator"
                                                    >
                                                        {sort == "ASC" ? 'Oldest first' : 'Newest First'}
                                                    </DropdownToggle>

                                                    <DropdownMenu right className="dropdown-menu-xs">

                                                        <ul className="link-check">
                                                            <li>
                                                                <span>Order</span>
                                                            </li>
                                                            <li className={sort === "DESC" ? "active" : ""}>
                                                                <DropdownItem
                                                                    tag="a"
                                                                    href="#dropdownitem"
                                                                    onClick={(ev) => {
                                                                        ev.preventDefault();
                                                                        setSortState("DESC");
                                                                        sortFunc("DESC");
                                                                    }}
                                                                >
                                                                    Newest First
                                                                </DropdownItem>
                                                            </li>
                                                            <li className={sort === "ASC" ? "active" : ""}>
                                                                <DropdownItem
                                                                    tag="a"
                                                                    href="#dropdownitem"
                                                                    onClick={(ev) => {
                                                                        ev.preventDefault();
                                                                        setSortState("ASC");
                                                                        sortFunc("ASC");
                                                                    }}
                                                                >
                                                                    Oldest first
                                                                </DropdownItem>
                                                            </li>
                                                        </ul>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </Col>
                        </Row> */}

                        <div className="card-inner-group">                        

                            <DataTable className="card-stretch">
                                <DataTableBody compact>
                                    <DataTableHead>
                                        {/* <DataTableRow>
                      <span className="sub-text">User</span>
                    </DataTableRow> */}
                                        <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Debit Note/Invoice Number</span>
                                        </DataTableRow>
                                        {/* <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Child Designer Name</span>
                                        </DataTableRow> */}

                                        
                                        <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Reason</span>
                                        </DataTableRow>

                                        <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Description</span>
                                        </DataTableRow>

                                        <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Debit Note Amount</span>
                                        </DataTableRow>

                                        <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Adjusted Amount</span>
                                        </DataTableRow>

                                        <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Pending Amount</span>
                                        </DataTableRow>                                                                    

                                        {/* <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Date Added</span>
                                        </DataTableRow> */}
                                        {/* <DataTableRow size="sm">
                                            <span className="thead-bold-txt table-head">Added By</span>
                                        </DataTableRow>                                */}
                                    </DataTableHead>

                                    {data?.length > 0
                                        ? data?.map((item, index) => {
                                            return (
                                                <DataTableItem key={item.id}>

                                                    <DataTableRow size="sm">
                                                        <span>{item?.open_debit_note_number}</span> 
                                                    </DataTableRow>

                                                    {/* <DataTableRow size="sm">
                                                        <span>{item?.child_designer_name}</span>
                                                    </DataTableRow> */}
                                                    
                                                    <DataTableRow size="sm">
                                                        <span>{item?.reason}</span>
                                                    </DataTableRow>   

                                                    <DataTableRow size="sm">
                                                        <span>{item?.description}</span>
                                                    </DataTableRow>

                                                    <DataTableRow size="sm">
                                                        <span>{item?.debit_note_amount}</span>
                                                    </DataTableRow>  
                                                    
                                                    <DataTableRow size="sm">
                                                        <span>{item?.adjusted_amount}</span>
                                                    </DataTableRow>

                                                    <DataTableRow size="sm">
                                                        <span>{item?.pending_amount}</span>
                                                    </DataTableRow>
                                                                                                                                                          
                                                    {/* <DataTableRow size="sm">
                                                        <span>{getDateFormat(item?.date_added)}</span>
                                                    </DataTableRow>                                             */}
                                                    {/* <DataTableRow size="sm">
                                                        <span>{item?.added_by}</span>
                                                    </DataTableRow> */}

                                                </DataTableItem>
                                            );
                                        })
                                        : null}

                                </DataTableBody>

                                <div className="card-inner">
                                    {data.length > 0 ? (
                                        // <PaginationComponent
                                        //   itemPerPage={itemPerPage}
                                        //   totalItems={totalCount}
                                        //   paginate={paginate}
                                        //   currentPage={currentPage}
                                        // />

                                        <PaginationComponent
                                            itemPerPage={itemPerPage}
                                            totalItems={totalCount || []}
                                            paginate={paginate}
                                            currentPage={currentPage}
                                            setItemPerPage={setItemPerPage}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    ) : (
                                        <div className="text-center">
                                            <span className="text-silent">No data found</span>
                                        </div>
                                    )}
                                </div>
                            </DataTable>
                        </div>

                    </Card>
                </Block>
            </Content>


            <Modal size="lg" isOpen={modalLg} toggle={toggleLg}>
                <ModalHeader
                    toggle={toggleLg}
                    close={
                        <button className="close" onClick={toggleLg}>
                            <Icon name="cross" />
                        </button>
                    }
                >
                    View Tracking Details
                </ModalHeader>
                <ModalBody>
                    <div className="nk-tnx-details mt-sm-3">
                        <Row className="gy-3">
                            <Col lg={6}>
                                <span className="sub-text">Courier Name</span>
                                <span className="caption-text">{trackingData?.ShippingCompanyName}</span>
                            </Col>
                            <Col lg={6}>
                                <span className="sub-text">Tracking Number</span>
                                <span className="caption-text">{trackingData?.trackingIDRtv}</span>
                            </Col>
                            <Col lg={6}>
                                <span className="sub-text">Date of Dispatch</span>
                                <span className="caption-text">{moment(trackingData?.trackDateRtv).format('DD-MM-YYYY')}</span>
                            </Col>
                        </Row>
                    </div>

                </ModalBody>
            </Modal>





            <Modal size="lg" isOpen={dispatchModal} toggle={toggleDispatchModal}>
                <ModalHeader
                    toggle={toggleDispatchModal}
                    close={
                        <button className="close" onClick={toggleDispatchModal}>
                            <Icon name="cross" />
                        </button>
                    }
                >
                    Dispatch PO
                </ModalHeader>
                <ModalBody>

                    {/* <div className="nk-modal-head">
            <h4 className="nk-modal-title title">
              Product 
                <small className="text-primary">#676568</small>
            </h4>            
          </div> */}
                    <div className="nk-tnx-details mt-sm-3">



                        <Form className={formClass} onSubmit={handleSubmit(onFormSubmit)}>
                            <Row className="g-gs">

                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-label" htmlFor="po_numbers">
                                            PO Number*
                                        </Label>
                                        <div className="form-control-wrap">
                                            <input
                                                type="text"
                                                id="po_numbers"
                                                className="form-control"
                                                name="po_numbers"
                                                ref={register()}
                                                defaultValue={poNumber}
                                                readOnly
                                            />
                                            {errors.po_numbers && <span className="invalid">This field is required</span>}
                                        </div>
                                    </FormGroup>
                                </Col>

                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-label" htmlFor="courier_name">
                                            Courier Name*
                                        </Label>
                                        <div className="form-control-wrap">
                                            <input
                                                type="text"
                                                id="courier_name"
                                                className="form-control"
                                                name="courier_name"
                                                ref={register({ required: true })}
                                            />
                                            {errors.courier_name && <span className="invalid">This field is required</span>}
                                        </div>
                                    </FormGroup>
                                </Col>


                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-label" htmlFor="tracking_number">
                                            Tracking Number*
                                        </Label>
                                        <div className="form-control-wrap">
                                            <input
                                                type="text"
                                                id="tracking_number"
                                                className="form-control"
                                                name="tracking_number"
                                                ref={register({ required: true })}
                                            />
                                            {errors.tracking_number && <span className="invalid">This field is required</span>}
                                        </div>
                                    </FormGroup>
                                </Col>

                                <Col md="6">
                                    <FormGroup style={{ zIndex: '99' }}>
                                        <label className="form-label">Dispatch Date*</label>
                                        <Controller
                                            control={control}
                                            name="dispatch_date"
                                            render={(props) => (
                                                <DatePicker
                                                    className="input"
                                                    placeholderText="Select date"
                                                    onChange={(e) => {
                                                        props.onChange(e);
                                                        setDispatchDate(moment(e).format('YYYY-MM-DD'))
                                                    }}
                                                    selected={props.value}
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    customInput={
                                                        <div className="form-control-wrap">
                                                            <input
                                                                ref={register({ required: true })}
                                                                type="text"
                                                                id="dispatch_date"
                                                                name="dispatch_date"
                                                                className="form-control"
                                                                // defaultValue={financialDetails?.dispatch_date}
                                                                value={dispatchDate}
                                                                autoComplete="off"
                                                            />
                                                            {errors.dispatch_date && <span className="invalid">This field is required</span>}
                                                        </div>
                                                    }
                                                />
                                            )}
                                        />
                                    </FormGroup>
                                </Col>

                            </Row>
                            <Row className="g-gs">
                                <Col md="12">
                                    <FormGroup>
                                        <Button type="submit" color="primary" size="lg">
                                            Submit
                                        </Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </div>

                </ModalBody>
            </Modal>









            <Modal size="sm" isOpen={userGuideModal} toggle={toggleuserGuideModal}>
                <ModalHeader
                    toggle={toggleuserGuideModal}
                    close={
                        <button className="close" onClick={toggleuserGuideModal}>
                            <Icon name="cross" />
                        </button>
                    }
                >

                    {infoText == 'status' && 'Terms used – “Status” column:'}

                    {infoText == 'trackingStatus' && 'Terms used – “Tracking status” column:'}

                    {infoText == 'purchaseOrder' && 'User guide for using purchase orders dashboard:'}


                </ModalHeader>
                <ModalBody>

                    <div className="nk-tnx-details mt-sm-3">

                        {infoText == 'status' && <>

                            {/* <p className="lead">Terms used – “Status” column:</p> */}
                            <table className="table table-bordered mt-3 table-sm">
                                <tbody>
                                    <tr>
                                        <th scope="row" width={'30%'} >Risk of cancellation</th>
                                        <td>If PO is not dispatched by designer after the PO delivery date, there is a risk of cancellation by customer which is reflected in this status. </td>
                                    </tr>
                                    <tr>
                                        <th scope="row" width={'30%'} >Delayed</th>
                                        <td>If PO is not dispatched by designer 3 days before the PO delivery date status is shown as “Delayed”.</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" width={'30%'} >Might get delayed</th>
                                        <td>If PO is not dispatched by designer 6 days before the PO delivery date, then status is shown as “Might get delayed”.</td>

                                    </tr>
                                    <tr>
                                        <th scope="row" width={'30%'} >On time</th>
                                        <td>For all other cases, status is shown as “On time”</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>}



                        {infoText == 'trackingStatus' && <>
                            {/* <p className="lead">Terms used – “Tracking status” column:</p> */}
                            <table className="table table-bordered mt-3 table-sm">
                                <tbody>
                                    <tr>
                                        <th scope="row" width={'30%'} >Pending</th>
                                        <td>PO is not dispatched by designer </td>
                                    </tr>
                                    <tr>
                                        <th scope="row" width={'30%'} >Dispatched</th>
                                        <td>PO is dispatched by designer </td>
                                    </tr>
                                    <tr>
                                        <th scope="row" width={'30%'} >Delivered to Aza</th>
                                        <td>Product is received by Aza </td>

                                    </tr>
                                    <tr>
                                        <th scope="row" width={'30%'} >Completed</th>
                                        <td>Product is marked as “Quality check – Passed” by Aza </td>
                                    </tr>



                                    <tr>
                                        <th scope="row" width={'30%'} >Failed quality check</th>
                                        <td>Product is marked as “Quality check – Failed” by Aza </td>
                                    </tr>



                                    <tr>
                                        <th scope="row" width={'30%'} >Returned by Aza to fix</th>
                                        <td>Aza sends back the product for correction after quality checks fail</td>
                                    </tr>



                                    <tr>
                                        <th scope="row" width={'30%'} >Rejected</th>
                                        <td>Aza sends back the product permanently after quality checks fail </td>
                                    </tr>


                                    <tr>
                                        <th scope="row" width={'30%'} >Cancelled</th>
                                        <td>PO is cancelled by Aza </td>
                                    </tr>

                                </tbody>
                            </table>

                        </>}

                        {infoText == 'purchaseOrder' &&

                            <div>
                                {/* <p className="lead">User guide for using purchase orders dashboard:</p> */}

                                <li>
                                    Click on “Download PO” to download a copy of Purchase order.
                                </li>

                                <li>Dispatch PO: When the tracking status of a PO is either “Pending” or “Returned by Aza to fix”, user will be able to dispatch PO. Click on the three dots under action column and select “Dispatch PO”. A pop up will open where user needs to enter dispatch details – Courier Name, Tracking Number and Dispatch Date. Once dispatch is done, it will be reflected in “tracking status” column.
                                </li>

                                <li>View tracking details: When the tracking status of PO is either “Returned by Aza to fix” or “Rejected”, user can view the tracking details of shipment sent by Aza. Click on the three dots under action column and select “View Tracking Details”. Users can view below details – Courier name, tracking number and date of dispatch.
                                </li>

                            </div>
                        }
                    </div>

                </ModalBody>
            </Modal>
            <ToastContainer />
        </React.Fragment>
    );
};
export default OpenDebitNoteListing;
